module.exports = __webpack_public_path__ + "assets/img/user2.b0877804.svg";